import {decorate, observable} from 'mobx';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons';
import {BaseModel} from './base';
import i18n from '../i18n/i18n';
import {displayableProperty} from './displayableProperty';
import {displayablePropertyParam} from './displayablePropertyParam';
import {transformation} from '../utils/transformations';

export class OperationState extends BaseModel {
  static faIcon = faCheckCircle;

  searchableProperties = ['name'];

  displayableProperties = [
    displayableProperty({
      key: 'name',
      title: i18n.t('operationState.model.attributes.name'),
      params: [displayablePropertyParam({path: 'name'})],
    }),
    displayableProperty({
      key: 'description',
      title: i18n.t('operationState.model.attributes.description'),
      params: [displayablePropertyParam({path: 'description'})],
    }),
    displayableProperty({
      key: 'color',
      title: i18n.t('operationState.model.attributes.color'),
      raw: true,
      params: [displayablePropertyParam({path: 'color', transform: transformation.color})],
    }),
  ];

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.phase = rootStore.phaseStore.getById(this.phaseId);
    this.inspectionTaskPhase = rootStore.phaseStore.getById(this.inspectionTaskPhaseId);
  }

  static prepareApiPayload(model) {
    return {
      id: model.id || undefined,
      name: model.name,
      description: model.description,
      isInitial: Boolean(model.isInitial),
      isFinal: Boolean(model.isFinal),
      isAbort: Boolean(model.isAbort),
      isAutomatic: Boolean(model.isAutomatic),
      isDelayedReporting: Boolean(model.isDelayedReporting),
      isInterruption: Boolean(model.isInterruption),
      isOneWay: Boolean(model.isOneWay),
      isShownInHistory: Boolean(model.isShownInHistory),
      sortOrder: model.sortOrder || null,
      color: model.color,
      phaseId: model.phaseId || null,
      inspectionTaskPhaseId: model.inspectionTaskPhaseId || null,
      properties: model.properties,
    };
  }
}

decorate(OperationState, {
  id: observable,
  name: observable,
  description: observable,
  isInitial: observable,
  isFinal: observable,
  isAbort: observable,
  isAutomatic: observable,
  isDelayedReporting: observable,
  isInterruption: observable,
  isOneWay: observable,
  isShownInHistory: observable,
  color: observable,
  phase: observable,
  inspectionTaskPhaseId: observable,
  phaseId: observable,
  properties: observable,
});
